import { UPDATE_PAYMENT_TYPE } from './updatePaymentType';
import { UPDATE_CURRENT_STAGE } from './updateCurrentStage';
import { GET_VO_PROPOSALS_OPTIONS } from './getVOProposalsOptions';
import { UPDATE_VENDOR_OPPORTUNITY } from './updateVendorOpportunity';
import { Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS } from './getDealInfoFromExternalDms';
import { UPSERT_VENDOR_OPPORTUNITY_REVENUE } from './upsertVendorOpportunityRevenue';
import { UPSERT_VENDOR_OPPORTUNITY_REVENUE_FROM_CALCULATIONS } from './upsertVendorOpportunityRevenueFromCalculations';
import { GET_CALCULATED_REVENUE } from './getCalculatedRevenue';
import { UPDATE_ESTIMATED_CLOSE_DATE } from './updateEstimatedCloseDate';
import { GET_VENDOR_OPPORTUNITY_REVENUE_BREAKDOWN } from './getVendorOpportunityRevenueBreakdown';

export const VOApi = {
  update: UPDATE_VENDOR_OPPORTUNITY,
  updateCurrentStage: UPDATE_CURRENT_STAGE,
  updatePaymentType: UPDATE_PAYMENT_TYPE,
  updateEstimatedCloseDate: UPDATE_ESTIMATED_CLOSE_DATE,
  fetchProposalOptions: GET_VO_PROPOSALS_OPTIONS,
  getDealInfoFromExternalDms: Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS,
  upsertVendorOpportunityRevenue: UPSERT_VENDOR_OPPORTUNITY_REVENUE,
  upsertVendorOpportunityRevenueFromCalculations: UPSERT_VENDOR_OPPORTUNITY_REVENUE_FROM_CALCULATIONS,
  getCalculatedRevenue: GET_CALCULATED_REVENUE,
  getVendorOpportunityRevenueBreakdown: GET_VENDOR_OPPORTUNITY_REVENUE_BREAKDOWN,
};
